import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, Signal, ViewChild } from '@angular/core';
import { ButtonModule, CheckboxModule, DialogModule, DialogService, MenuModule } from '@sag-ui';
import { filter, fromEvent, switchMap, tap } from 'rxjs';
import { scrollOverAmountElement } from '../../utils/tiny-helpers';
import { GeneralCod } from '../../../cod/models/cod.model';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { DeleteCod } from '../../../home/state/cod-overview.action';
import { UserPipe } from '../../pipes/user.pipe';
import { DeleteCodDialogComponent } from '../../../home/dialogs/delete-cod/delete-cod.component';

@Component({
    selector: 'app-cod-overview-table',
    templateUrl: './cod-overview-table.component.html',
    imports: [CommonModule, CheckboxModule, ButtonModule, MenuModule, UserPipe, DialogModule],
    standalone: true
})
export class CodOverviewTableComponent implements AfterViewInit {
    @Input() items: GeneralCod[] = [];
    @Input() heading: string;
    @Input() headerClasses: string;
    @Input() borderClasses: string;
    @Input() isLoading$: Signal<boolean>;
    @Input() isLazyLoading$: Signal<boolean>;
    @Input() allLoaded$: Signal<boolean>;
    @Input() showOptions = false;

    @Output() rowClick: EventEmitter<GeneralCod> = new EventEmitter<GeneralCod>();
    @Output() lazyLoad: EventEmitter<void> = new EventEmitter<void>();

    @ViewChild('table', { static: true }) table!: ElementRef;

    public open = true;

    ngAfterViewInit(): void {
        this.initScrollListener();
    }

    constructor(private router: Router, private store: Store, private dialogService: DialogService) {}

    public copy(id: string): void {
        this.router.navigate(['cod', 'create'], { queryParams: { copy: id } });
    }

    public deleteCod(id: string): void {
        const dialogRef = this.dialogService.open<string, { id: string }>(DeleteCodDialogComponent, {
            width: '500px',
            data: {
                id
            }
        });

        dialogRef.afterClosed
            .pipe(
                filter(value => !!value),
                switchMap(() => this.store.dispatch(new DeleteCod(id)))
            )
            .subscribe();
    }

    private initScrollListener(): void {
        fromEvent<Event>(this.table.nativeElement, 'scroll')
            .pipe(
                filter(() => !this.isLazyLoading$()),
                tap((event: Event) => {
                    if (!scrollOverAmountElement(event) || this.allLoaded$()) {
                        return;
                    }

                    this.lazyLoad.emit();
                })
            )
            .subscribe();
    }
}
